export class DiffSelectionEvent extends Event {
  constructor() {
    super('diff-line-selection', {
      bubbles: false,
      cancelable: true,
    })
  }
}

declare global {
  interface WindowEventMap {
    'diff-line-selection': DiffSelectionEvent
  }
}

export function publishDiffSelection(): void {
  window.dispatchEvent(new DiffSelectionEvent())
}
